// Sidebar bölümlerinin merkezi kayıt tablosu.
// Yeni bir sidebar öğesi eklerseniz burada da tanımlayın; hem Yöneticiler
// ekranındaki checkbox listesinde hem Layout filtresinde otomatik çalışır.
//
// group değerleri: main | data-entry | reports | merkez | trendyol
// (trendyol öğeleri fiziksel olarak merkez altında render ediliyor,
// ama izin/checkbox listelerinde ayrı grup olarak görünsün diye ayrılmıştır.)

export const SIDEBAR_SECTIONS = [
  // ── Ana Yönetim ──
  { key: "panel", label: "Panel", group: "main", adminOnly: false },
  { key: "personnel", label: "Personel", group: "main" },
  { key: "timesheet", label: "Puantaj", group: "main" },
  { key: "advance-requests", label: "Avans Talepleri", group: "main" },
  { key: "personnel-requests", label: "Personel Talepleri", group: "main" },
  { key: "support", label: "Talep / Destek", group: "main" },

  // ── Veri Girişleri ──
  { key: "expense-categories", label: "Masraf Kalemleri", group: "data-entry" },
  { key: "expense-analytics", label: "Masraf Analizi", group: "data-entry" },
  { key: "product-types", label: "Ürün Listesi", group: "data-entry" },
  { key: "stock-catalog", label: "Stok Kataloğu", group: "data-entry" },
  { key: "report-new", label: "Rapor Ekle", group: "data-entry" },
  { key: "import", label: "Toplu İçe Aktar", group: "data-entry" },

  // ── Raporlar ──
  { key: "balance", label: "Bilanço", group: "reports" },
  { key: "daily-summary", label: "Günlük Özetler", group: "reports" },
  { key: "stock-count", label: "Stok Sayımı", group: "reports" },
  { key: "branch-performance", label: "Şube Performansı", group: "reports" },
  { key: "consumption", label: "Fire / Zayi", group: "reports" },
  { key: "reports", label: "Son Girilen Raporlar", group: "reports" },

  // ── Merkez Bölümü ──
  { key: "branches", label: "Şubeler", group: "merkez" },
  { key: "users", label: "Yöneticiler", group: "merkez", adminOnly: true },
  { key: "user-permissions", label: "Yetki Matrisi", group: "merkez", adminOnly: true },
  { key: "merkez-report", label: "Merkez Rapor", group: "merkez" },
  { key: "merkez-expense-categories", label: "Merkez Masraf Kalemleri", group: "merkez" },
  { key: "joker-takip", label: "Joker Takip", group: "merkez", adminOnly: true },
  { key: "franchise", label: "Franchise Görüşmeleri", group: "merkez", adminOnly: true },
  { key: "unlav-orders", label: "Unlav Lavaş Siparişi", group: "merkez" },
  { key: "muhasebe-cari", label: "Muhasebe Cari", group: "finans", adminOnly: true },
  { key: "menuboard", label: "Menü Board", group: "merkez" },
  { key: "online-menus", label: "Menüler", group: "merkez" },
  { key: "recipes", label: "Reçeteler", group: "merkez" },

  // ── Operasyon ──
  { key: "storage-usage", label: "Depolama Kullanımı", group: "operasyon", adminOnly: true },
  { key: "notification-settings", label: "Bildirim Ayarları", group: "operasyon", adminOnly: true },
  { key: "daily-email", label: "Günlük Kasa E-postası", group: "operasyon", adminOnly: true },
  { key: "announcements", label: "Duyurular", group: "operasyon", adminOnly: true },
  { key: "support-settings", label: "Destek Atamaları", group: "operasyon" },
  { key: "audit-log", label: "Denetim Kaydı", group: "operasyon", adminOnly: true },
  { key: "online-panel", label: "Online Panel Verileri", group: "operasyon" },

  // ── Finans ──
  { key: "head-office", label: "Merkez Personeli", group: "finans" },
  { key: "merkez-daily", label: "Merkez Günlük", group: "finans" },
  { key: "merkez-account-payments", label: "Hesaptan Ödenenler", group: "finans" },
  { key: "rent-tracking", label: "Kira Takibi", group: "finans" },
  { key: "meal-card-payments", label: "Yemek Kartı Ödemeleri", group: "finans" },
  { key: "ys-reconcile", label: "Yemek Sepeti Mutabakat", group: "finans" },

  // ── Trendyol Go ──
  { key: "trendyol", label: "Trendyol Ayarları", group: "trendyol", adminOnly: true },
  { key: "trendyol-store-map", label: "Trendyol Şube Eşleştirme", group: "trendyol", adminOnly: true },
  { key: "trendyol-live", label: "Trendyol Canlı Sipariş", group: "trendyol" },
  { key: "trendyol-reconcile", label: "Trendyol Ciro Karşılaştırma", group: "trendyol", adminOnly: true },
  { key: "trendyol-analytics", label: "Trendyol Analitik", group: "trendyol" },
  { key: "trendyol-products", label: "Trendyol Ürünler", group: "trendyol" },
  { key: "trendyol-mutabakat", label: "Trendyol Mutabakat", group: "trendyol", adminOnly: true },
  { key: "trendyol-anomalies", label: "Trendyol Anomaliler", group: "trendyol" },
  { key: "trendyol-claims", label: "Trendyol İade Talepleri", group: "trendyol", adminOnly: true },
  { key: "whatsapp", label: "WhatsApp", group: "main" },
  { key: "utility-bills", label: "Şube Fatura Takip", group: "finans" },
  { key: "migros-mutabakat", label: "Migros Mutabakat", group: "finans", adminOnly: true },

  // ── Platform Analitiği (Trendyol · Yemek Sepeti · Migros) ──
  { key: "platform-analytics", label: "Platform Analitiği", group: "platform", adminOnly: true },
  { key: "platform-uploads", label: "Rapor Yükleme", group: "platform", adminOnly: true },
  { key: "platform-matching", label: "Şube Eşleştirme", group: "platform", adminOnly: true },
];

// Rol başına varsayılan görünen bölümler (allowed_sections null/undefined ise kullanılır).
// Böylece eski kullanıcılar veya kolayca "operasyon rolü ver, uğraşmayayım" seçeneği çalışır.
const ALL_MAIN = SIDEBAR_SECTIONS.filter((s) => (s.group === "main" || s.group === "data-entry" || s.group === "reports") && !s.adminOnly).map((s) => s.key);
const ALL_ADMIN = SIDEBAR_SECTIONS.map((s) => s.key);

export const ROLE_DEFAULT_SECTIONS = {
  admin: ALL_ADMIN,
  operasyon: ALL_MAIN,   // merkez ve trendyol hariç her şey
  accounting: ["merkez-daily", "meal-card-payments"],
  regional_manager: ALL_MAIN,
  branch: ["panel", "reports", "trendyol-live", "trendyol-analytics", "trendyol-products", "support", "advance-requests", "personnel-requests"],  // şube: rapor + canlı sipariş + analitik + ürün yönetimi + talepler
};

/**
 * Kullanıcının hangi bölümleri görebileceğini hesaplar.
 * - user.allowed_sections tanımlıysa onu kullanır
 * - Yoksa role'e göre varsayılana düşer
 * - Admin-only bölümler (users, audit-log) role != "admin" ise elenir
 */
export function resolveVisibleSections(user) {
  if (!user) return new Set();
  const role = user.role || "";
  const explicit = user.allowed_sections;
  let keys;
  let usingExplicit = false;
  // Boş dizi durumu = "yapılandırma yok" olarak yorumlanır → role default'a fallback (sidebar tamamen kaybolmasın).
  // Bilerek kısıtlamak isteyen admin, kullanıcıyı disable etmelidir.
  if (Array.isArray(explicit) && explicit.length > 0) {
    keys = explicit;
    usingExplicit = true;
  } else {
    keys = ROLE_DEFAULT_SECTIONS[role] || [];
  }
  const set = new Set(keys);
  // Şube için DesenERP Sipariş + Cari Ekstre — sadece `branch.desen_enabled` aktifse görünür (Unlav pattern)
  if (role === "branch" && user.desen_enabled) {
    set.add("desen-orders");
    set.add("desen-cari-ekstre");
  }
  // Admin-only guards: yalnızca role default'a düşüldüğünde uygula.
  // Admin bir bölümü kullanıcıya açıkça yetkilendirdiyse, adminOnly bayrağı
  // bu izni ezmez — "yetki verdim ama görünmüyor" sorununu önler.
  if (role !== "admin" && !usingExplicit) {
    for (const s of SIDEBAR_SECTIONS) {
      if (s.adminOnly) set.delete(s.key);
    }
  }
  // Readonly section'lar sidebar'da mutlaka görünmelidir (invariant: readonly ⊂ visible)
  const ro = Array.isArray(user.readonly_sections) ? user.readonly_sections : [];
  for (const k of ro) set.add(k);
  return set;
}

/** Bir bölümün kullanıcı için salt-okuma olup olmadığı. */
export function isSectionReadOnly(user, sectionKey) {
  if (!user || !sectionKey) return false;
  const ro = user.readonly_sections;
  if (!Array.isArray(ro)) return false;
  return ro.includes(sectionKey);
}

/** Basit hook: mevcut route'un section key'ini otomatik tanımak yerine
 *  komponentler kendi section key'ini geçer. */
export function useSectionAccess(user, sectionKey) {
  const visible = resolveVisibleSections(user);
  return {
    canView: visible.has(sectionKey),
    readOnly: isSectionReadOnly(user, sectionKey),
    canEdit: visible.has(sectionKey) && !isSectionReadOnly(user, sectionKey),
  };
}
